import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type KpiContent } from 'types/models';

export interface KPIContentsState extends EntityState<KpiContent>, ActiveState {}

const store = createEntityStore<KPIContentsState>({}, { resettable: true, name: 'kpiContents' });

export default store;
